import { RadioFieldGroup } from '@iheartjane/reefer';
import capitalize from 'lodash-es/capitalize';
import compact from 'lodash-es/compact';

/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';

import styles from './groupDiscountButton.module.css';

const groupDiscountLabel = (special: StoreSpecial) => {
  const { discount_type, discount_percent, discount_dollar_amount, rules } =
    special;

  const groupRules = rules?.base;
  if (!groupRules?.type) return null;

  const applicableGroup = groupRules.type;

  const seniorAgeRequirement =
    applicableGroup === 'senior' && `(${groupRules.required_age}+)`;

  const pediatricAgeRequirement =
    applicableGroup === 'pediatric' && `(${groupRules.required_age} and under)`;

  const discountAmount =
    discount_type === 'percent'
      ? `${discount_percent}%`
      : `$${discount_dollar_amount}`;

  const groupLabel =
    applicableGroup === 'senior'
      ? `${capitalize(applicableGroup)} ${seniorAgeRequirement}`
      : applicableGroup === 'pediatric'
        ? `Pediatric/Minor ${pediatricAgeRequirement}`
        : `${capitalize(applicableGroup)}`;

  return `${groupLabel} – ${discountAmount} OFF`;
};

const discountItems = (groupDiscounts: StoreSpecial[]) =>
  compact(
    groupDiscounts.map((special) => {
      const label = groupDiscountLabel(special);

      if (!special.rules?.base?.type || !label) return null;

      return {
        value: special.id.toString(),
        label,
      };
    })
  ).concat([
    {
      value: '',
      label: 'None',
    },
  ]);

interface DiscountButtonProps {
  analyzingSpecials?: boolean;
  groupDiscounts: StoreSpecial[];
  selectedSpecial?: string | number;
  selectSpecial: (specialId?: string | number) => void;
}

export const GroupDiscountButton = ({
  analyzingSpecials,
  groupDiscounts,
  selectSpecial,
  selectedSpecial,
}: DiscountButtonProps) => {
  return (
    <RadioFieldGroup
      defaultChecked={selectedSpecial?.toString()}
      name="groupDiscount"
      onChange={(value) => {
        selectSpecial(parseInt(value as string) || undefined);
      }}
      options={discountItems(groupDiscounts).map((item) => ({
        id: item.value,
        value: item.value.toString(),
        label: item.label,
      }))}
      disabled={analyzingSpecials}
      className={styles['groupDiscountButton']}
    />
  );
};
